export default __webpack_public_path__ + "static/media/03Loman.2781d706.jpg";